<template>
  <div class="order-supplier-request-tasks position-relative">
    <div class="fly-header">
      <h5 class="mb-0">{{ tableTitle }}</h5>
    </div>

    <tsoft-table
      :name="typeOfTableFilter"
      :key="componentRefreshKey"
      :api="tableApiUrl"
      :items.sync="items"
      :isNeedSearch="false"
      :isNeedCreate="false"
      :additionalGetParameter="additionalGetParameter"
      :typeOfTableFilter="''"
      :onDataEmptyMessage="'Отправленные письма отсутствуют, создайте задание, нажав кнопку «Отправить письма поставщикам».'"
      :headerContextMenuName="'emailTrackingTable'"
      @show="showItem"
      @delete="deleteItem"
      @selectItem="selectItem"
      @onLoad="onLoad"
    />  
    
    <EmailTrackingDetailWidgetLocal
      v-if="editedItemId && editedItemId != -1"
      :id="editedItemId"
      @onClose="onCloseEmailTrackingDetailWidget"
    ></EmailTrackingDetailWidgetLocal>

    <!-- Sidebar or Dialog for Desire and Comment -->
    <b-sidebar
      v-model="isDesireSidebarVisible"
      title="Оставьте решение"
      right
      shadow
      backdrop
      width="400px"
    >
      <div class="p-3">
        <b-form-group label="Решение">
          <b-form-radio-group
            v-model="editedDesire"
            :options="[
              { text: 'Не указано', value: null },
              { text: 'Можно сотрудничать', value: true },
              { text: 'Не будем сотрудничать', value: false }
            ]"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group label="Ставка / Комментарий к решению">
          <b-form-textarea
            v-model="editedDesireComment"
            rows="8"
            max-rows="12"
            style="line-height: 18px;"
            placeholder="Оставьте комментарий..."
          ></b-form-textarea>
        </b-form-group>

        <div class="text-right">
          <b-button variant="primary" @click="saveDesire" :disabled="!canSaveDesire">Сохранить решение</b-button>
        </div>
      </div>
    </b-sidebar>    
  </div>
</template>

<script>
import { API_EMAIL_TRACKING, HOST_FOR_STORAGE } from "@/constants";
import { 
    defaultDataItems,
    actionShowItem,
    actionDeleteItem,
    dataHelpers
} from "@/mixins";

import EmailTrackingDetailWidgetLocal from "@/components/emailTracking/EmailTrackingDetailWidgetLocal";

export default {
  mixins: [
    defaultDataItems, 
    actionShowItem,
    actionDeleteItem,
    dataHelpers
  ],
  props: {
    additionalGetParameter: { type: String, required: false, default: '' },
    typeOfTableFilter: { type: String, required: false, default: 'email-tracking' },
    tableTitle: { type: String, default: 'Письма поставщикам' }
  },
  components: {
    EmailTrackingDetailWidgetLocal
  },    
  data() {
    return {
      changeLoad: false,
      tableApiUrl: API_EMAIL_TRACKING,
      componentRefreshKey: 0,
      isShowSidebar: false,
      hfs: HOST_FOR_STORAGE,
      editedItemId: -1,
      isDesireSidebarVisible: false,
      editedDesire: null,
      editedDesireComment: '',
      currentDesireItemId: null        
    };
  },
  computed: {
    canSaveDesire() {
      return this.editedDesireComment.trim() !== '';
    }
  },
  methods: { 
    showItem(index) {
      let item = this.items.data[index];
      this.editedItemId = item.id;
    },
    selectItem(index) {
      let item = this.items.data[index];
      this.currentDesireItemId = item.id;
      this.editedDesire = item.desire !== null ? item.desire : null;
      this.editedDesireComment = item.desire_comment || '';
      this.isDesireSidebarVisible = true;
    },
    saveDesire() {
      const payload = {
        desire: this.editedDesire,
        desire_comment: this.editedDesireComment
      };
      
      api.call('put', `${API_EMAIL_TRACKING}/${this.currentDesireItemId}`, payload)
        .then(response => {
          this.$bvToast.toast('Решение сохранено успешно.', {
            title: 'Успешно сохранено!',
            variant: 'success',
            solid: true
          });
          this.isDesireSidebarVisible = false;
          this.componentRefreshKey++;
        })
        .catch(error => {
          console.error('Error updating decision:', error);
          this.$bvToast.toast('Не получилось сохранить решение. Попробуйте снова или обратитесь к администратору системы.', {
            title: 'Ошибка сохранения',
            variant: 'danger',
            solid: true
          });
        });
    },
    onCloseEmailTrackingDetailWidget() {
      this.editedItemId = -1;
    },
    onDeletedCallback() {
      this.componentRefreshKey++;
    },
    onLoad() {
      this.$emit('onLoad', this.items.total);
    },
  }
};
</script>

<style scoped>
.fly-header {
  position: absolute;
  left: 0px;
  top: 5px;
}
</style>
